import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTravelBillingInfoStart,
  getTravelBillingInfoSuccess,
  getTravelBillingInfoFailure,
} from "../reducers/getTravelBillingInfoReducer.js";
import axios from "axios";
import Cookies from "js-cookie";

export const getTravelBillingInfo = createAsyncThunk(
  "getTravelBillingInfo",
  async ({ Unique_ID, PaymentType }, thunkAPI) => {
    try {
      thunkAPI.dispatch(getTravelBillingInfoStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Travel/GetBillingInfo?Unique_ID=${Unique_ID}&PaymentType=${PaymentType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(
        getTravelBillingInfoSuccess(responseData?.data?.result)
      );

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(
        getTravelBillingInfoFailure(error.response.data.Message)
      );

      throw error;
    }
  }
);
